<template>
  <div class="slideBox monthly-active-users-app" :class="this.$route.query.source">

    <div class="slideHeader">
      <h1>
        <span class="source">{{ this.$route.query.sourceTitle }}</span>
        Nutzer
      </h1>
    </div>

    <div class="total-value monthly-active-users-app-total">
      <h2>Monthly active users</h2>
      <div class="big value">
        <i-count-up
          :start="0"
          :end="totalValueEnd"
          :duration="countDuration"
          :options="options"
        ></i-count-up>
      </div>
      <div class="day">Gestern</div>
    </div>

    <div class="circles">

      <transition name="swap-in" appear>
        <div class="circle monthly-active-users-app-7days" :class="[days7Value < 0 ? 'down' : 'up']">
          <div class="big value">{{ days7Value.toString().replace('.', ',') }}%</div>
          <div class="day">
            <span class="day-range-firstValue">Gestern</span>
            <span class="day-range-divider"></span>
            <span class="day-range-secondValue">7 Tage zuvor</span>
          </div>
        </div>
      </transition>

      <transition name="swap-in" appear>
        <div class="circle monthly-active-users-app-14days" :class="[days14Value < 0 ? 'down' : 'up']">
          <div class="big value">{{ days14Value.toString().replace('.', ',') }}%</div>
          <div class="day">
            <span class="day-range-firstValue">Gestern</span>
            <span class="day-range-divider"></span>
            <span class="day-range-secondValue">14 Tage zuvor</span>
          </div>
        </div>
      </transition>

      <transition name="swap-in" appear>
        <div class="circle monthly-active-users-app-21days" :class="[days21Value < 0 ? 'down' : 'up']">
          <div class="big value">{{ days21Value.toString().replace('.', ',') }}%</div>
          <div class="day">
            <span class="day-range-firstValue">Gestern</span>
            <span class="day-range-divider"></span>
            <span class="day-range-secondValue">21 Tage zuvor</span>
          </div>
        </div>
      </transition>

    </div>

  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import _ from 'lodash'

export default {
  name: 'monthly-active-users-app',
  components: {
    ICountUp
  },
  data () {
    return {
      countDuration: this.$store.state.countDuration,
      totalValueEnd: 0,
      days7Value: 0,
      days14Value: 0,
      days21Value: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    }
  },
  mounted () {
    const theme = this.$route.query.theme
    const source = this.$route.query.source
    const urlPart = theme + '-' + source + '_monthly_active_users_app'

    /* total value */
    const totalValueURL = urlPart + '-yesterday'
    this.axios.get(totalValueURL).then((response) => {
      this.totalValueEnd = parseInt(_.head(response.data.results).monthlyActiveUsers)
    })

    /* 7 days */
    const days7ValueURL = urlPart + '-yesterday_vs_7_days_ago'
    this.axios.get(days7ValueURL).then((response) => {
      this.days7Value = _.head(response.data.results).perc
    })

    /* 14 days */
    const days14ValueURL = urlPart + '-yesterday_vs_14_days_ago'
    this.axios.get(days14ValueURL).then((response) => {
      this.days14Value = _.head(response.data.results).perc
    })

    /* 21 days */
    const days21ValueURL = urlPart + '-yesterday_vs_21_days_ago'
    this.axios.get(days21ValueURL).then((response) => {
      this.days21Value = _.head(response.data.results).perc
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/monthly-active-users-app.vue